import React, { useState, useEffect } from 'react';

// Components
import { ErrorPage, LoadingPage } from 'components/ui/states';

// Utility
import { useAuth } from 'context/auth';
import { Redirect } from 'react-router-dom';

export default function HostRedirect(props) {
    const { auth, setHost } = useAuth();

    const [error, setError] = useState(false);

    const params = new URLSearchParams(props.location.search);

    const hostId = Number(params.get('host_id'));
    const hostName = decodeURIComponent(params.get('host_name'));

    // Update the host when user lands on this page
    useEffect(() => {
        if (hostId && hostName) {
            setHost(hostId, hostName);
        } else {
            setError(true);
        }
        // eslint-disable-next-line
    }, [hostId, hostName]);

    // Update the host in the auth context

    // If the host in the auth context matches the one passed in via params, then redirect to the home page
    // Otherwise, display a loading page

    if (error) {
        // Error occurred. Redirect to home page
        return <ErrorPage message="Unable to find that host" />;
    }

    if (auth.hostId === hostId) {
        // Host ID has been updated. Redirect to home page
        return <Redirect to="/" />;
    } else {
        // Host ID not updated yet. Display loading page
        return <LoadingPage />;
    }
}
